import { render } from "./Contract.vue?vue&type=template&id=67081d36&scoped=true"
import script from "./Contract.vue?vue&type=script&lang=js"
export * from "./Contract.vue?vue&type=script&lang=js"

import "./Contract.vue?vue&type=style&index=0&id=67081d36&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67081d36"]])

export default __exports__